var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 431,
    viewBox: "0 0 435 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 215.549,
    width: 24.5676,
    height: 24.5676,
    transform: "rotate(-45 0.707107 215.549)",
    stroke: "#AC9FFF",
    className: "svg-elem-1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 401.079,
    y: 215.549,
    width: 23.0304,
    height: 23.0304,
    transform: "rotate(-45 401.079 215.549)",
    stroke: "#AC9FFF",
    className: "svg-elem-2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_149_1347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 185.399L32.8027 185.045L32.4491 185.399L32.8027 185.753L33.1562 185.399ZM64.4829 216.726L64.8365 217.079L65.19 216.726L64.8365 216.372L64.4829 216.726ZM217.555 1L217.909 0.646447L217.555 0.292893L217.202 0.646447L217.555 1ZM403.394 186.838L403.747 187.192L404.101 186.838L403.747 186.485L403.394 186.838ZM373.506 216.726L373.153 216.372L372.799 216.726L373.153 217.079L373.506 216.726ZM401.96 245.179L402.314 245.533L402.667 245.179L402.314 244.826L401.96 245.179ZM217.555 429.584L217.202 429.938L217.555 430.291L217.909 429.938L217.555 429.584ZM34.5898 246.619L34.2363 246.265L33.8827 246.619L34.2363 246.972L34.5898 246.619ZM32.8027 185.753L64.1294 217.079L64.8365 216.372L33.5098 185.045L32.8027 185.753ZM217.202 0.646447L32.8027 185.045L33.5098 185.753L217.909 1.35355L217.202 0.646447ZM403.747 186.485L217.909 0.646447L217.202 1.35355L403.04 187.192L403.747 186.485ZM373.86 217.079L403.747 187.192L403.04 186.485L373.153 216.372L373.86 217.079ZM402.314 244.826L373.86 216.372L373.153 217.079L401.606 245.533L402.314 244.826ZM217.909 429.938L402.314 245.533L401.606 244.826L217.202 429.231L217.909 429.938ZM34.2363 246.972L217.202 429.938L217.909 429.231L34.9434 246.265L34.2363 246.972ZM64.1294 216.372L34.2363 246.265L34.9434 246.972L64.8365 217.079L64.1294 216.372Z",
    stroke: "url(#paint0_linear_149_1347)",
    strokeWidth: 1,
    fill: "none",
    className: "svg-elem-3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_149_1347",
    x: 12.4492,
    y: -19.707,
    width: 411.651,
    height: 469.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_149_1347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_149_1347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_1347",
    x1: 218.275,
    y1: 1,
    x2: 218.275,
    y2: 429.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5948C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5948C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareIcon);
export default __webpack_public_path__ + "static/media/SquareIcon.a4d43fce7aa4eb168c5e91f8365712b4.svg";
export { ForwardRef as ReactComponent };